export default __webpack_public_path__ + "static/media/2.82048e30.png";